import { Modal } from "tailwindcss-stimulus-components";

export default class extends Modal {
  static targets = ["reload"];

  static values = {
    backdropColor: { type: String, default: "rgba(0, 0, 0, 0.8)" },
    restoreScroll: { type: Boolean, default: true },
    scrollTo: String,
  };

  initialLoadingContent = {};

  modalId = undefined;

  reloadTargetConnected(target) {
    if (target.identity === undefined) {
      target.identity = Math.random();
    }

    this.initialLoadingContent[target.identity] = target.innerHTML;
  }

  open(event) {
    this.modalId = event?.params?.modalId;
    super.open(event);

    // Once open, if set, scroll to given scrollTo target
    if (event?.params?.scrollTo) {
      this.containerTarget.querySelector(event.params.scrollTo).scrollIntoView();
    }

    this.reloadTargets.forEach((target) => {
      target.innerHTML = this.initialLoadingContent[target.identity];
      target.reload?.();
    });
  }

  get dialogTarget() {
    const modalTarget = this.dialogTargets.find((target) => this.modalId && target.id === this.modalId);

    return modalTarget || this.dialogTargets[0];
  }
}
